var React = require('react');

function FieldMessage (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"stroke","transform":"translate(-718.000000, -2701.000000)","stroke":"#231F20","strokeWidth":"1.5"},React.createElement("g",{"transform":"translate(720.000000, 2224.000000)"},React.createElement("g",{"transform":"translate(0.000000, 147.000000)"},React.createElement("g",{"transform":"translate(0.000000, 297.000000)"},React.createElement("g",{"transform":"translate(0.000000, 34.000000)"},React.createElement("polygon",{"fill":"#FFFFFF","points":"0 283.427246 12.4419556 -1.2180144e-14 527 -1.2180144e-14 514.214481 119.946299 535.642896 119.946299 527 264.543579"}))))))));
}

FieldMessage.defaultProps = {"preserveAspectRatio":"none","width":"539px","height":"286px","viewBox":"0 0 539 286","version":"1.1"};

module.exports = FieldMessage;

FieldMessage.default = FieldMessage;
